/**
 * SportForce Theme - Shopify JavaScript
 *
 * Handles:
 * - Preloader fade-out
 * - Header scroll effect (backdrop-blur)
 * - Intersection Observer for fade-in animations
 *
 * @package SportForce Shopify
 */

(function () {
    'use strict';

    // ============================
    // Preloader
    // ============================
    const preloader = document.getElementById('sfPreloader');

    if (preloader) {
        window.addEventListener('load', function () {
            setTimeout(function () {
                preloader.classList.add('fade-out');
                setTimeout(function () {
                    preloader.style.display = 'none';
                }, 500);
            }, 300);
        });
    }

    // ============================
    // Header Scroll Effect
    // ============================
    function initHeaderScroll() {
        const header = document.querySelector('.section-header');
        if (!header) return;

        const scrollThreshold = 50;
        let scrollTicking = false;

        function handleScroll() {
            const currentScrollY = window.scrollY || window.pageYOffset;

            if (currentScrollY > scrollThreshold) {
                header.classList.add('scrolled');
            } else {
                header.classList.remove('scrolled');
            }
        }

        window.addEventListener('scroll', function () {
            if (!scrollTicking) {
                window.requestAnimationFrame(function () {
                    handleScroll();
                    scrollTicking = false;
                });
                scrollTicking = true;
            }
        }, { passive: true });

        // Run once on page load
        handleScroll();
    }

    // ============================
    // Intersection Observer: Fade-In Animations
    // ============================
    function initScrollAnimations() {
        // Auto-apply sf-animate to key sections for automatic fade-in
        var autoAnimateSelectors = [
            '.image-with-text',
            '.image-with-text__media-item',
            '.image-with-text__text-item',
            '[class*="featured-collection"]',
            '.collection-list',
            '.rich-text__wrapper'
        ];

        autoAnimateSelectors.forEach(function (selector) {
            document.querySelectorAll(selector).forEach(function (el) {
                if (!el.classList.contains('sf-animate')) {
                    el.classList.add('sf-animate');
                }
            });
        });

        var animatedElements = document.querySelectorAll('.sf-animate');

        if (!animatedElements.length) return;

        if ('IntersectionObserver' in window) {
            var observer = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('visible');
                        observer.unobserve(entry.target);
                    }
                });
            }, {
                root: null,
                rootMargin: '0px 0px -60px 0px',
                threshold: 0.1
            });

            animatedElements.forEach(function (el) {
                observer.observe(el);
            });
        } else {
            // Fallback: show all immediately
            animatedElements.forEach(function (el) {
                el.classList.add('visible');
            });
        }
    }

    // ============================
    // Smoke & Ember Particles on Banners
    // ============================
    function initSmokeParticles() {
        var bannerMediaElements = document.querySelectorAll('.banner__media, .slideshow__media');
        if (!bannerMediaElements.length) return;

        // Weighted particle types
        var particlePool = [
            'ember', 'ember', 'ember',
            'smoke', 'smoke', 'smoke', 'smoke',
            'spark', 'spark', 'spark', 'spark', 'spark',
            'haze', 'haze',
            'ash', 'ash', 'ash'
        ];

        bannerMediaElements.forEach(function (media) {
            media.style.overflow = 'hidden';

            var particleCount = 20 + Math.floor(Math.random() * 9);
            for (var i = 0; i < particleCount; i++) {
                createParticle(media, particlePool);
            }
        });

        function randRange(min, max) {
            return min + Math.random() * (max - min);
        }

        function createParticle(container, pool) {
            var particle = document.createElement('div');
            var type = pool[Math.floor(Math.random() * pool.length)];
            particle.className = 'sf-smoke-particle sf-smoke-particle--' + type;

            // Spawn mostly at the bottom, spread horizontally
            var posX = randRange(2, 98);
            var posY = randRange(65, 98);  // bottom 35% of the banner
            particle.style.left = posX + '%';
            particle.style.top = posY + '%';

            // Size by type
            var size, peakOpacity;
            switch (type) {
                case 'spark':
                    size = randRange(2, 6);
                    peakOpacity = 0.9;
                    break;
                case 'ash':
                    size = randRange(4, 12);
                    peakOpacity = 0.5;
                    break;
                case 'ember':
                    size = randRange(25, 70);
                    peakOpacity = 0.5;
                    break;
                case 'smoke':
                    size = randRange(80, 160);
                    peakOpacity = 0.2;
                    break;
                case 'haze':
                    size = randRange(150, 300);
                    peakOpacity = 0.15;
                    break;
                default:
                    size = 40;
                    peakOpacity = 0.5;
            }
            particle.style.width = size + 'px';
            particle.style.height = size + 'px';

            // Upward rise distance (negative = up)
            var rise = -(100 + Math.random() * 300);
            // Slight horizontal sway
            var dx = (Math.random() - 0.5) * 60;
            particle.style.setProperty('--rise', rise + 'px');
            particle.style.setProperty('--dx', dx + 'px');
            particle.style.setProperty('--peak-opacity', peakOpacity);

            // Random timing per particle
            var delay = Math.random() * 12;
            var dur;
            switch (type) {
                case 'spark':
                    dur = randRange(3, 6);
                    break;
                case 'ash':
                    dur = randRange(5, 10);
                    break;
                case 'ember':
                    dur = randRange(7, 14);
                    break;
                case 'smoke':
                    dur = randRange(10, 18);
                    break;
                case 'haze':
                    dur = randRange(12, 22);
                    break;
                default:
                    dur = 8;
            }
            particle.style.setProperty('--delay', delay + 's');
            particle.style.setProperty('--dur', dur + 's');

            container.appendChild(particle);
        }
    }

    // ============================
    // Initialize All
    // ============================
    function init() {
        initHeaderScroll();
        initScrollAnimations();
        initSmokeParticles();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

})();
